import store from '~client/store';
import { pmsAllowRoles } from '~constants';

const showElementByAuth = (target, requireAuth) => {
  const authJS = store.getState().pmsReducer.auth.toJS();

  return (
    target &&
    requireAuth &&
    authJS &&
    authJS.auth &&
    authJS.auth.authMapping &&
    authJS.auth.authMapping[target] &&
    authJS.auth.authMapping[target].indexOf(requireAuth.toUpperCase()) !== -1
  );
};

export const isInternalRole = () => {
  const authJS = store.getState().pmsReducer.auth.toJS();
  return (
    authJS &&
    authJS.auth &&
    authJS.auth.currentRoleSlug &&
    authJS.auth.currentRoleSlug !== 'landlord'
  );
};

export const isLandlordRole = () => {
  const authJS = store.getState().pmsReducer.auth.toJS();
  return (
    authJS &&
    authJS.auth &&
    authJS.auth.currentRoleSlug &&
    authJS.auth.currentRoleSlug === 'landlord'
  );
};

export const showLandlordManaging = () => {
  const authJS = store.getState().pmsReducer.auth.toJS();
  return (
    authJS &&
    authJS.auth &&
    authJS.auth.currentRoleSlug &&
    (authJS.auth.currentRoleSlug === 'admin' || authJS.auth.currentRoleSlug === 'supply')
  );
};

export const isSupplyRole = () => {
  const authJS = store.getState().pmsReducer.auth.toJS();
  return (
    authJS && authJS.auth && authJS.auth.currentRoleSlug && authJS.auth.currentRoleSlug === 'supply'
  );
};

export const isContentSpecialistRole = () => {
  const authJS = store.getState().pmsReducer.auth.toJS();
  return (
    authJS &&
    authJS.auth &&
    authJS.auth.currentRoleSlug &&
    authJS.auth.currentRoleSlug === 'content_manager_level_2'
  );
};

export const formatAuthPayload = (payload, role) => {
  const newPayload = { ...payload };
  const authMapping = {};
  let currentRole;
  if (
    newPayload &&
    newPayload.identity &&
    newPayload.identity.identity &&
    newPayload.identity.identity.frontendScopes
  ) {
    currentRole = newPayload.identity.identity.frontendScopes.find(
      frontendScope => frontendScope.role === role,
    );
    currentRole.scopes.map(scope => {
      if (scope.object && scope.permission) {
        authMapping[scope.object] = scope.permission;
      }
      return true;
    });
  }
  return { currentRoleSlug: role, authMapping };
};

export const isAllowRole = roles => {
  let allowedRole = null;
  if (typeof roles === 'object' && roles.length > 0) {
    allowedRole = roles.find(role => pmsAllowRoles.indexOf(role) !== -1);
  }

  return !!allowedRole;
};

export const getAvailableRoles = frontendScopes => {
  if (!Array.isArray(frontendScopes)) {
    return [];
  }

  const availableRoles = [];
  frontendScopes.map(scope => {
    if (pmsAllowRoles.includes(scope.role)) {
      availableRoles.push(scope.role);
    }
    return true;
  });

  return availableRoles;
};

export default showElementByAuth;
